import { Text, TextProps } from '@mantine/core';
import { FC } from 'react';

const metricTextStyle: TextProps['style'] = {
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
};

type SamplerCoverageMetricTextProps = TextProps & {
  value: string;
};

export const SamplerCoverageMetricText: FC<SamplerCoverageMetricTextProps> = ({
  value,
  ...props
}) => (
  <Text size="sm" style={metricTextStyle} {...props}>
    {value}
  </Text>
);
